import type { CSSProperties } from "react";
import { REPORT_FONT_FAMILY } from "../../utils/reportPageLayout";

export const CLINICAL_REPORT_FONT_FAMILY = REPORT_FONT_FAMILY;

export const CLINICAL_REPORT_BODY_STYLE = {
  fontFamily: CLINICAL_REPORT_FONT_FAMILY,
  fontSize: "11pt",
  fontWeight: 400,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
} satisfies CSSProperties;
